/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { DEFAULT_GATEWAY_EN, DEFAULT_GATEWAY_FR } from "../../../const/const";

import { useFetch } from "./useFetch";

const useFetchGoingToOptions = lang => {
	const [data, setData] = useState([]);

	const [processing, _fetchData] = useFetch();
	const fetchData = gateway => {
		_fetchData(
			`${process.env.GATSBY_LPC_API_BASE_URL}SV/search/getDestCode/${lang}/SWG/${gateway}`
		).then(result => {
			setData(
				result?.reduce((accumulator, i) => {
					accumulator.push({
						label: i.groupName,
						value: i.groupCode,
						group: true,
					});

					i.destination.forEach(d => {
						if (d.destCode)
							accumulator.push({
								label: d.destName,
								value: d.destCode,
							});
					});

					return accumulator;
				}, [])
			);
		});
	};
	useEffect(() => {
		fetchData(lang === "fr" ? DEFAULT_GATEWAY_FR : DEFAULT_GATEWAY_EN);
	}, []);
	return [data, processing, fetchData];
};

export default useFetchGoingToOptions;
export { useFetchGoingToOptions };
